import MetalLImage from "@/images/metal_l@2x.png";
import MetalMImage from "@/images/metal_m@2x.png";
import MetalAIImage from "@/images/metal_ai@2x.png";
import MetalAJImage from "@/images/metal_aj@2x.png";
import MetalAUImage from "@/images/metal_au@2x.png";

export default [
  {
    shape: "春秋",
    name: "春秋龍鳳",
    code: "L",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 6,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 20,
      },
    },
    imagePath: MetalLImage,
    engravingContentType: "default",
  },
  {
    shape: "春秋",
    name: "春秋雙龍",
    code: "M",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 20,
      },
    },
    imagePath: MetalMImage,
    engravingContentType: "default",
  },
  {
    shape: "春秋",
    name: "伽藍韋馱護法",
    code: "AI",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 1,
        textLimit: 5,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 20,
      },
    },
    imagePath: MetalAIImage,
    engravingContentType: "default",
  },
  {
    shape: "春秋",
    name: "雙龍賜福",
    code: "AJ",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 1,
        textLimit: 12,
        maxFontsize: 16,
      },
    },
    imagePath: MetalAJImage,
    engravingContentType: "default",
  },
  {
    shape: "春秋",
    name: "翔龍賜福",
    code: "AU",
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 5,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 40,
      },
      gift: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 16,
      },
    },
    imagePath: MetalAUImage,
    engravingContentType: "default",
  },
];
